var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextRaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#123766"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 27V9.90002C11.5 9.90002 12.375 9 15 9C17.625 9 19.375 10.8 22 10.8C24.625 10.8 25.5 9.9 25.5 9.9V20.7C25.5 20.7 24.625 21.6 22 21.6C19.375 21.6 17.625 19.8 15 19.8C12.375 19.8 11.5 20.7 11.5 20.7",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextRaceIcon);
export default __webpack_public_path__ + "static/media/nextRaceIcon.47a8a3f1dbb082dc3cde18cc5ffa474b.svg";
export { ForwardRef as ReactComponent };